<template>
    <div class="min-h-screen background-logo flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div class="max-w-md w-full space-y-8">
            <!-- Header -->
            <div class="text-center">
                <h1 class="text-4xl font-bold text-white mb-2 drop-shadow-lg text-shadow">
                    Connexion
                </h1>
                <p class="text-gray-200 drop-shadow-md text-shadow">
                    Connectez-vous à votre compte Liview
                </p>
            </div>

            <!-- Formulaire -->
            <div class="background-color backdrop-blur-sm rounded-xl shadow-2xl p-8 border border-white/20">
                <form @submit.prevent="handleLogin" class="space-y-6">
                    <!-- Username -->
                    <div>
                        <label for="username" class="block text-sm font-medium text-gray-700 mb-2">
                            Nom d'utilisateur
                        </label>
                        <input 
                            id="username"
                            type="text" 
                            v-model="username" 
                            placeholder="Entrez votre nom d'utilisateur"
                            class="input-background w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-white placeholder-gray-300"
                            :class="{ 'border-red-500': error && !username }"
                            required
                        />
                    </div>

                    <!-- Password -->
                    <div>
                        <label for="password" class="block text-sm font-medium text-gray-700 mb-2">
                            Mot de passe
                        </label>
                        <input 
                            id="password"
                            type="password" 
                            v-model="password" 
                            placeholder="Entrez votre mot de passe"
                            class="input-background w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-white placeholder-gray-300"
                            :class="{ 'border-red-500': error && !password }"
                            required
                        />
                    </div>

                    <!-- Error Message -->
                    <div v-if="error" class="bg-red-50 border border-red-200 rounded-lg p-4">
                        <div class="flex">
                            <svg class="w-5 h-5 text-red-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                            </svg>
                            <p class="text-red-600 text-sm">{{ error }}</p>
                        </div>
                    </div>

                    <!-- Submit Button -->
                    <button 
                        type="submit"
                        :disabled="isLoading"
                        class="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                    >
                        <svg v-if="isLoading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        {{ isLoading ? 'Connexion...' : 'Se connecter' }}
                    </button>

                    <!-- Link to Register -->
                    <div class="text-center">
                        <p class="text-gray-600 text-sm">
                            Pas de compte ? 
                            <router-link to="/register" class="text-blue-600 hover:text-blue-500 font-medium transition-colors duration-200">
                                Créer un compte
                            </router-link>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import * as NAMESPACE_STORE from "../vuexStore/namespaceStore.js";

export default {
    name: "Login",
    data() {
        return {
            username: "",
            password: "",
            error: "",
            isLoading: false
        }
    },
    computed: {
        ...mapGetters(NAMESPACE_STORE.USER, {
            isLoggedIn: "isLoggedIn"
        })
    },
    watch: {
        // Rediriger automatiquement si l'utilisateur est connecté
        isLoggedIn(newValue) {
            if (newValue) {
                this.$router.push('/editor');
            }
        }
    },
    methods: {
        ...mapActions(NAMESPACE_STORE.USER, {
            loginAction: "login"
        }),
        handleLogin() {
            if (!this.username || !this.password) {
                this.error = "Veuillez remplir tous les champs";
                return;
            }
            this.isLoading = true;
            this.error = "";
            this.loginAction({
                username: this.username,
                password: this.password,
            }).then(() => {
                this.$router.push('/editor');
            }).catch(error => {
                this.error = "Erreur de connexion. Vérifiez vos identifiants.";
                console.error('Erreur login:', error);
            }).finally(() => {
                this.isLoading = false;
            });
        }
    }
}
</script>

<style scoped>
.background-logo {
    background-image: url('/assets/images/logo.png');
    background-repeat: no-repeat;
  background-position: 50% 30%;
  background-size: contain;
}
.text-shadow {
    text-shadow: 0px 0px 2px rgb(0, 0, 0);
}
.background-color {
    background-color: #ffffffc9;
}
.input-background {
    background-color: #2b2a33;
}
</style>